// extracted by mini-css-extract-plugin
module.exports =  {"well":"YRGefr6IZXNmD6v0nYaF","summary":"TzA5idfSIqnAVy8fKvJc","fields":"dUd9X08X9NM7Dy51VG0H","problems":"acMNfYW8h66PuswTEonj","actions":"fBx2xaYKXWW9zt1kec7Q"};